<div class="row mb-1">
  <div class="col">
    <div class="card " style="overflow-x:hidden; overflow-y:visible; height:800px;">

      <!-- //////////////////////////////// Participant Agreement///////////////////////////////////// -->

      <div class="row mb-2">
        <div class="col">
          <div class="card ">
            <div class="row">
              <div class="col text-end mb-3 mt-3">
                <button type="button" class="btn blue-btn me-5 mt-2" (click)="CommonSave()"
                  *ngIf="global.LoginUserType.toUpperCase() == 'ONBOARD'" [disabled]="clientonboardBO?.isCompleted">Save
                  All</button>&nbsp;
                <button type="button" class="btn blue-btn btn-sm me-5 mt-2" (click)="SaveDocument()"
                  *ngIf="global.LoginUserType.toUpperCase() != 'ONBOARD'" [disabled]="clientonboardBO?.isCompleted ||isSaveorUpdateBoolean">Save
                  All</button>&nbsp;
                <button type="button" class="btn blue-btn me-5 mt-2" (click)="submitClientAggrementDetails()"
                  *ngIf="global.LoginUserType.toUpperCase() == 'ONBOARD'"
                  [disabled]="clientonboardBO?.statusinfo=='Submitted'">Submit</button>
                <button data-bs-toggle="modal" data-bs-target="#sendtoclient" *ngIf="global.LoginUserType != 'Onboard'"
                  [disabled]="clientonboardBO?.statusinfo=='Waiting For Acknowledgement' || clientonboardBO?.statusinfo=='Submitted'"
                  class="btn btn-sm me-3 mt-2"> Send To Client</button>

                <button class="btn btn-sm px-3 mb-3 mt-3 ms-2" data-bs-toggle="modal"
                  *ngIf="global.LoginUserType != 'Onboard' &&  clientonboardBO?.statusinfo=='Submitted'"
                  [disabled]="clientonboardBO?.isCompleted" data-bs-target="#completemodal">Complete</button>
              </div>
            </div>

            <div class="card-body" style="padding-left:85px;padding-right:85px;">

              <div class="row">
                <h3><b>Participant Agreement</b></h3>
              </div>

              <div class="row mt-4">
                <p>The participant is set-up as a household employer responsible for hiring and managing
                  employees. The employer can be the person receiving services or their representative. The
                  person who has authority to sign documents related to employer set-up is:</p>
                <ul style="margin-left:30px">
                  <li>An adult participant</li>
                  <li>
                    A parent signing for a minor

                  </li>
                  <li>A guardian (a copy of the guardian paperwork must be provided)</li>
                </ul>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; is a Financial
                Management Service (FMS) enrolled with the Department of Human
                Services (DHS) as a MN Health Care Provider. &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; FMS acts as a
                Fiscal/Employer Agent
                under <input type="text" class="form-control mb-2" [disabled]="clientonboardBO?.isCompleted "
                  [(ngModel)]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.fmsAct"
                  style="width: 100px;display: inline-block;"> and is responsible for
                enrolling employees; processing
                timesheets, invoices, and reimbursements; tax filing; billing and program reporting.
              </div>
              <div class="row mt-2">
                The agreement takes effect after intake completion and renews on the next plan’s start date or
                date of that plan’s lead agency signature, whichever is later. To avoid service gaps, plans should
                be submitted to the lead agency 30 days prior to the current plan’s expiration.
              </div>
              <div class="row mt-2">
                Services start when &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; FMS:
              </div>
              <ul style="margin-left:30px">
                <li>receives a service authorization and plan from the lead agency
                </li>
                <li>an employer is set up with Workers’ Compensation if needed and</li>
                <li>enrolled employees have successfully completed a background check</li>
              </ul>

              <div class="row mt-2">
                <p>Fees are charged according to DHS published rates. In addition, there are employer taxes and
                  benefits billed to the budget based on the employer’s experience and the age and relationship
                  of the employee to the employer. &nbsp; <b style="display: inline-block">&nbsp; <b
                      style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; FMS fees are <input
                    type="text" class="form-control mb-2" (keypress)="NumbersOnly($event)"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing"
                    [disabled]="clientonboardBO?.isCompleted" style="width: 100px;display: inline-block;"> &nbsp;/month
                  for a
                  CDCS budget with
                  staffing; <input type="text" class="form-control mb-2"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods"
                    (keypress)="NumbersOnly($event)" [disabled]="clientonboardBO?.isCompleted "
                    style="width: 100px;display: inline-block;"> &nbsp;/month for a
                  CDCS budget with goods only; and <input type="text" class="form-control mb-2"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget"
                    (keypress)="NumbersOnly($event)" [disabled]="clientonboardBO?.isCompleted "
                    style="width: 100px;display: inline-block;"> &nbsp;/month for a CSG
                  budget.</p>
              </div>
              <div class="row mt-2">
                <h3><b>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS Roles and
                    Responsibilities </b></h3>
              </div>
              <div class="row mt-2">
                Acts as third-party designee and obtains an Employer Identification Number (EIN) for the
                participant with completion and filing of IRS Form SS-4.



              </div>
              <div class="row mt-2">
                Assists with completion and filing of IRS Form 2678 appointing &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS as the agent
                responsible for filing federal taxes for the employer. &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS is responsible for tax
              </div>
              <div class="row mt-2">
                obligations from the service start until approval of agent status is received.
                Obtains a MN Tax ID for the employer with completion and filing of the Application for Business
                Registration.
              </div>
              <div class="row mt-2">
                Assists in the completion and filing of MN Rev 184 which appoints &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS limited power
                of attorney for the purpose of state withholding tax.
              </div>
              <div class="row mt-2">
                Acts as the employer’s Unemployment Insurance (UI) agent, establishes an account when
                needed, represents the employer in UI matters and receives related mailings.



              </div>
              <div class="row mt-2">
                Obtains a Workers’ Compensation policy for the employer if needed. If the employer has their
                own policy, a copy must be provided before employees start work and when the policy renews.
              </div>
              <div class="row mt-2">
                Maintains and processes employee applications including background checks, fingerprint
                authorizations, Unique MN Provider Identifier applications, W-4s, I-9s, pay notices and
                relationship disclosures.
              </div>
              <div class="row mt-2">
                Reports new hires to MN for child support obligations, processes worker garnishments in
                accordance with federal and state laws and deducts union dues if required.
              </div>
              <div class="row mt-2">
                Provides Employer and Employee Handbooks that include information on federal and state
                laws, resources, and policies for Mandated Reporting, Fraud and HIPAA.



              </div>
              <div class="row mt-2">
                Makes payment authorized in the plan in accordance with approved time entries and federal
                and state labor laws such as the Fair Labor Standards Act.
              </div>
              <div class="row mt-2">
                Calculates and deposits employer and employee payroll taxes, issues W-2s and refunds over
                collected FICA.
              </div>
              <div class="row mt-2">
                Provide vendor packets with W-9s, pays service vendors and issues 1099s.
              </div>
              <div class="row mt-2">
                Assists with orders and processes reimbursements Friday if the request is received Tuesday.


              </div>
              <div class="row mt-2">
                Sets up a budget based on the participant’s approved plan and tracks changes.
              </div>
              <div class="row mt-2">
                Makes monthly reports available showing budgeted and spent funds and reports overspending
                (>15%), underspending (>15%) and unapproved overtime. </div>
              <div class="row mt-2">

                Verifies program eligibility, suspends payment if eligibility has lapsed, and bills for
                services.
              </div>
              <div class="row mt-4">
                <h3><b>Participant/Representative Roles and Responsibilities</b></h3>
              </div>
              <div class="row mt-2">
                The employer recruits, hires, trains, supervises, and terminates employees.



              </div>
              <div class="row mt-2">
                Employees cannot be scheduled before &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS has notified the employer an
                employee
                can start. If an employee works before their start date, they will not be paid by &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS.
              </div>
              <div class="row mt-2">
                The employer will not discriminate against employees or applicants because of race, religion,
                national origin, sex (including pregnancy, sexual orientation, or gender identification),
                disability,
                age or any other status protected by law.
              </div>
              <div class="row mt-2">
                The employer maintains employee files with job descriptions, evaluations and records of
                tardiness, absenteeism, or termination if needed. The employer notifies &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; if an
                employee is ineligible for unemployment with documentation of employee performance.
              </div>
              <div class="row mt-2">
                The employer determines employee pay rates and benefits in compliance with program rules,
                the collective bargaining agreement, and local ordinances. Wage changes are communicated to


              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS in writing, in addition
                to being listed in the plan.
                Parents of minors and spouses are unable to work over 40 hours a week. Hours above 40 hours
                are considered unpaid natural supports.
              </div>
              <div class="row mt-2">
                If minors, 14 to 17 years old, are employed, minor labor laws must be followed.

              </div>
              <div class="row mt-2">
                Overtime is unapproved unless documented by the lead agency. Overtime occurs when an
                employee works more than 40 hours a week. If submitted, it is paid at 1.5 times the rate of pay.
              </div>
              <div class="row mt-2">
                The employer and employee submit time and are responsible for the accuracy of the hours. Pay
                dates are listed in the Payroll Calendar. Pay statements are available through CYMA. Hours



              </div>
              <div class="row mt-2">
                worked should be submitted by deadlines and no later than 30 days from the service date.
                The participant understands employees are mandated reporters under the Vulnerable Adult
                and Maltreatment of Minors Reporting Act. &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; staff are also mandated reporters.
              </div>
              <div class="row mt-2">
                The participant will report fraud to &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;, the lead agency or DHS.
              </div>
              <div class="row mt-2">
                The participant will notify &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;
                of admission to a care facility such as a hospital, group
                home, assisted living or nursing home. Employees cannot work during this time.
              </div>
              <div class="row mt-2">
                Participants with a patient responsibility must pay their spenddown or responsibility by the
                listed date. If patient responsibilities are not met, services may be suspended.



              </div>
              <div class="row mt-2">
                The participant completes necessary paperwork to maintain program eligibility.
              </div>
              <div class="row mt-2">
                The participant reviews spending reports to make sure information is accurate and adjusts
                spending if the budget is overspent.
              </div>
              <div class="row mt-2">
                The participant pays for goods, services or hours worked beyond budgeted funds.
              </div>
              <div class="row mt-4">
                <h3><b>Customer Service and Grievances</b></h3>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; strives to return calls and
                emails within a business day and provide responsive and
                respectful customer service. Grievances can be submitted online, by email or mail in the event
                there is an issue, and it is not resolved through communication with the &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS
                Coordinator. Grievances are investigated and resolved within 30 days. If the issue cannot be
                resolved within 30 days, the reason for the delay will be explained in writing
              </div>
              <div class="row mt-4">
                <h3><b>Termination</b></h3>
              </div>
              <div class="row mt-2">
                Either party may terminate this agreement. Once terminated, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS will revoke any
                agent appointments and close out Workers’ Compensation if obtained by &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS. When
                transferring to a different FMS provider, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS will work with the new provider
                to
                coordinate necessary information for tax filings and continuity of care.
              </div>
              <div class="row mt-2">
                <h3><b>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; Terminates FMS</b>
                </h3>
              </div>

              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS will provide written
                notice to the participant at least 10 days before the
                proposed service termination date unless DHS grants an exception. Exceptions include:
                <ul style="margin-left:30px">
                  <li>A hostile relationship characterized by lack of collaboration and
                    communication.

                  </li>
                  <li>Conduct resulting in a report being made to the Office of Inspector General
                    (OIG) or the Surveillance & Integrity Review Section (SIRS).</li>
                </ul>

              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS must send written
                notice to the participant and lead agency. The notice will
                include the effective date and reason for termination.

              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS can terminate services
                without cause, if the participant is given written notice
                at
                the payment of a quarter end and at least 30 days before termination.
              </div>
              <div class="row mt-2">
                <h3><b>Participant Terminates FMS</b></h3>
              </div>
              <div class="row mt-2">
                When a Participant initiates a request to terminate services, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS will respond with
                written acknowledgement within 5 business days. The acknowledgement will include the date
                the request was received, the requested termination date and the actual termination date
                services will occur if the requested date cannot be accommodated.
              </div>
              <div class="row mt-4">
                <h3><b>Agent Authorization</b></h3>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS is authorized:
                <ul style="margin-left:30px">
                  <li>To act as third-party designee for IRS Form SS-4 and obtain an EIN.


                  </li>
                  <li>To file Forms 2678 and Rev 184 for employer tax reporting.</li>
                  <li>To act as Unemployment Agent: apply for an account, fulfill employer
                    responsibilities (tax, benefits and appeals) and receive related documents.</li>
                  <li>To obtain Workers’ Compensation if a policy is needed. </li>

                </ul>
              </div>

              <div class="row mt-2">
                The authorization remains in effect until &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; no longer acts as Fiscal/Employer
                Agent.
              </div>

              <div class="row mt-4">
                <h3><b>Signatures and Effective Date </b></h3>
              </div>
              <div class="row mt-2">
                This Agreement is effective&nbsp;
                <my-date-picker style="width:150px;display: inline-block;"
                  [selDate]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate"
                  placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','effdate')"
                  (dateChanged)="newdates($event,'datechanged','effdate');" [disabled]="clientonboardBO?.isCompleted ">
                </my-date-picker>
                (date) between &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS and the
                participant
                employer and/or their representative&nbsp;
                <input type="text" [disabled]="clientonboardBO?.isCompleted"
                  [(ngModel)]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.clientName"
                  class="form-control" style="width:120px;display: inline-block;">
                (print name). By signing, the
                parties agree to the terms within; have reviewed and understand roles and responsibilities; and
                a Handbook has been provided with Mandated Reporting, HIPAA, Fraud and Grievance Policies.
              </div>

              <div class="row mt-4">
                <div class="col-6">
                  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Participant2"
                    [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'"> Participant/Representative Signature:
                  </button>
                </div>
                <div class="col-lg-1">
                  <label for="cname">Date: </label>
                </div>
                <div class="col-lg-3">
                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                    [selDate]="ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date"
                    placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','date')"
                    (dateChanged)="newdates($event,'datechanged','date');"
                    [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted">

                  </my-date-picker>
                </div>
              </div>



              <div class="row mt-2 mb-2">

                <div class="col-lg-4">
                  <input *ngIf="pantsign!=''&& pantsign!=null" type="image" src="{{pantsign}}" class="form-control"
                    style="width: 255px;height:120px;" alt="nurse" width="48" height="48" />
                </div>
              </div>
              <div class="row mt-2">

              </div>


            </div>
            <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" [disabled]="clientonboardBO?.isCompleted || isSaveorUpdateBoolean"
                    (click)="SaveDocument()">Save</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- //////////////////////////////////// Release Of Information/////////////////////////////////// /-->

      <div class="row mb-2">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:85px;">

              <div class="row mt-3">
                <h3><b>Release of Information
                  </b></h3>
              </div>
              <div class="row mt-4">
                <div class="col-lg-2">
                  <div class="row">
                    <label>Participant Name</label>
                  </div>

                </div>
                <div class="col-lg-4">
                  <input type="text" class="form-control" [disabled]="clientonboardBO?.isCompleted"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.participantName">
                </div>
              </div>
              <div class="row mt-3">
                <p>I authorize the release of my records /information between &nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; and the following</p>
                <ul style="margin-left:30px">
                  <li>Lead agency</li>
                  <li>Support planner</li>
                  <li>Plan vendors</li>
                  <li>FMS (if transferring from an FMS to obtain employer IDs, accounts and
                    spending reports to coordinate tax filing and program delivery)</li>
                  <li>
                    Other&nbsp;
                    <input type="text" class="form-control mb-2"
                      [(ngModel)]="ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.others"
                      [disabled]="clientonboardBO?.isCompleted " style="width: 180px;display: inline-block;">
                    &nbsp;
                  </li>
                </ul>
              </div>



              <div class="row mt-1">
                <div class="col-lg-10 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <label class="col-lg-8">I authorize &nbsp; <b
                      style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; to send unsecured communication
                    containing protected
                    health
                    information (PHI) by email:</label>
                  &nbsp;&nbsp;

                  <label>yes</label>&nbsp;

                  <div class="col-lg-1">
                    <input type="radio" value="true" name="select8" id="pre3"
                      [(ngModel)]="ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare"
                      (ngModelChange)="authchange($event)" [disabled]="clientonboardBO?.isCompleted ">
                  </div>

                  <label>
                    no
                  </label>&nbsp;

                  <div class="col-lg-1">
                    <input type="radio" value="false" name="select8" id="pre4"
                      [(ngModel)]="ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare"
                      (ngModelChange)="authchange($event)" [disabled]="clientonboardBO?.isCompleted ">

                  </div>
                </div>



              </div>

              <div class="row mt-2">
                I have been informed of the risks of transmitting PHI by unsecured means which include:
                <ul style="margin-left:30px;">
                  <li>Email that includes PHI will not be encrypted.</li>
                  <li>Unsecured email may not prevent others from accessing content.</li>
                  <li>Sending unsecured PHI exposes it to others who may use it maliciously.</li>
                  <li>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; has no control over
                    email access sent unsecured from our server.</li>

                </ul>
              </div>
              <div class="row mt-2">
                The authorization is valid for one year from the signature date unless specified. I may end the
                authorization by written request any time by contacting the &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; FMS.
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Participant3"
                    [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'"> Signature:
                  </button>

                </div>
                <div class="col-lg-1">
                  <label for="cname">Date:
                  </label>
                </div>
                <div class="col-lg-3">
                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                    [selDate]="ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate"
                    placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','date1')"
                    (dateChanged)="newdates($event,'datechanged','date1');"
                    [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted"></my-date-picker>
                </div>
              </div>
              <div class="row mt-2 mb-2">

                <div class="col-lg-4">
                  <input *ngIf="pantsign1!=''&& pantsign1!=null " type="image" src="{{pantsign1}}" class="form-control"
                    style="width: 255px;height:120px;" alt="nurse" width="48" height="48">
                </div>
              </div>


            </div>
            <div class="card-footer">
              <div class="col text-end mb-3 mt-3">

                <button type="button" class="btn blue-btn me-3" [disabled]="clientonboardBO?.isCompleted || isSaveorUpdateBoolean"
                  (click)="SaveDocument()">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- //////////////////////////////////// Application for Employer Identification /////////////////////////////////// /-->

      <div class="row mb-2">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">

              <div class="row">
                <div class="col-lg-2">
                  <h5>Form<h3><b>SS-4</b></h3>
                  </h5>
                  <p>(Rev. December 2023)</p>
                  <p>Department of the Treasury
                    Internal Revenue Service </p>
                </div>
                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-lg-12">
                      <h4><b>Application for Employer Identification Number</b></h4>
                      <p><b>(For use by employers, corporations, partnerships, trusts, estates, churches,
                          government agencies, Indian tribal entities, certain individuals, and others.)</b></p>
                      <p>
                        <b>
                          ▶ Go to www.irs.gov/FormSS4 for instructions and the latest information
                        </b>
                      </p>
                      <p><b>
                          ▶ See separate instructions for each line.&nbsp;&nbsp; ▶ Keep a copy for your records
                        </b></p>

                    </div>
                  </div>

                </div>
                <div class="col-lg-2">
                  <p>OMB No. 1545-0003</p>
                  <label>EIN </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.einnumber"
                    [disabled]="clientonboardBO?.isCompleted ">

                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <label>1&nbsp;&nbsp;Legal name of entity (or individual) for whom the EIN is being requested
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.legalname"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>

              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>2&nbsp;&nbsp;Trade name of business (if different from name on line 1)
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.tradename"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
                <div class="col-5">
                  <label>3&nbsp;&nbsp; Executor, administrator, trustee, “care of” name
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyName"
                    [disabled]="clientonboardBO?.isCompleted">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>4a&nbsp;&nbsp;Mailing address(room, apt., suite no. and street)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress"
                    [disabled]="clientonboardBO?.isCompleted"></textarea>
                </div>
                <div class="col-5">
                  <label>4b&nbsp;&nbsp;Street address(if Different)(Don’t enter a P.O. box)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyStreet"
                    [disabled]="clientonboardBO?.isCompleted "></textarea>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>5a&nbsp;&nbsp;City, state, and ZIP code (if foreign, see instructions)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip"
                    [disabled]="clientonboardBO?.isCompleted"></textarea>
                </div>
                <div class="col-5">
                  <label>5b&nbsp;&nbsp;City, state, and ZIP code (if foreign, see instructions)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zipIdifferent"
                    [disabled]="clientonboardBO?.isCompleted "></textarea>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-10">
                  <label>6&nbsp;&nbsp;County and state where principal business is located
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCounty"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>7a&nbsp;&nbsp;Name of responsible party
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.nameofResponsibleParty"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
                <div class="col-5" [formGroup]="EmployerIdentificationForm">
                  <label>7b&nbsp;&nbsp;SSN, ITIN, or EIN
                  </label>
                  <input type="text" class="form-control" formControlName="Identificationssn"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.ssn"
                    minlength="9" maxlength="9" [disabled]="clientonboardBO?.isCompleted "
                    (keypress)="keyPress($event)">
                  <span class="req" *ngIf="EmployerIdentificationForm.controls['Identificationssn'].invalid">

                    <p>*Enter Valid SSN, Enter 9 digit</p>
                  </span>

                </div>





              </div>

              <div class="row mt-2">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <div class="row">
                    <div class="col-lg-8">
                      <label>8a Is this application for a limited liability company (LLC) (or a foreign equivalent)? . .
                        .
                        . . . . .
                      </label>
                    </div>
                    <div class="col-lg-2">
                      <label>yes</label>
                      <input type="radio" value="true" id="pre5" name="xx"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc"
                        [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange1($event)">
                    </div>
                    <div class="col-lg-2">
                      <label>no</label>
                      <input type="radio" value="false" id="pre6" name="xx"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc"
                        [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange1($event)">

                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <label>8b&nbsp;&nbsp;If 8a is “Yes,” enter the number of
                    LLC members . . . . .
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.ifYesnumberofLlcMembers"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-8">
                      <label>8c&nbsp;&nbsp;If 8a is “Yes,” was the LLC organized in the United States?
                      </label>
                    </div>
                    <div class="col-lg-2">
                      <label>yes</label>
                      <input type="radio" id="pre7" name="select2" value="true"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates"
                        [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange2($event)">
                    </div>
                    <div class="col-lg-2">
                      <label>no</label>
                      <input type="radio" id="pre8" name="select2" value="false"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates"
                        [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange2($event)">

                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row mt-2">
                        <div class="col-8">

                          <label>9a&nbsp;&nbsp;Type of entity (check only one box). Caution:</label><label>If 8a is
                            “Yes,” see the instructions for the correct box to check.
                          </label>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-1">
                              <input type="radio" name="entity1" value="one" (click)="radio1()"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-6">
                              <label>Sole proprietor (SSN)
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool1 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn"
                                minlength="9" maxlength="9">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity2" (click)="event()" value="two"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-6">
                              <label>Partnership
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity3" value="three"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio2()" [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-6">
                              <label> Corporation (enter form number to be filed) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool2 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity4" (click)="event()"
                                [disabled]="clientonboardBO?.isCompleted " value="four"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Personal service corporation
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity5" value="five"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Church or church-controlled organization
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity6" value="six" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio3()">
                            </div>
                            <div class="col-lg-6">
                              <label> Other nonprofit organization (specify) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool3 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity7" value="seven"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio4()">
                            </div>
                            <div class="col-lg-6">
                              <label> Other (specify) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool4 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity8" value="eight"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio5()">
                            </div>
                            <div class="col-lg-6">
                              <label>Estate (SSN of decedent)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool5 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn"
                                minlength="9" maxlength="9">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity9" value="nine" [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio6()">
                            </div>
                            <div class="col-lg-6">
                              <label>Plan administrator (TIN)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool6 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity0" [disabled]="clientonboardBO?.isCompleted " value="ten"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio7()">
                            </div>
                            <div class="col-lg-6">
                              <label>Trust (TIN of grantor)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool7 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity11" (click)="event()"
                                [disabled]="clientonboardBO?.isCompleted " value="eleven"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Military/National Guard </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" name="entity12" (click)="event()"
                                [disabled]="clientonboardBO?.isCompleted " value="tweleve"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label> State/local government</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity13" value="thirdteen"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Farmers’ cooperative</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity14"
                                [disabled]="clientonboardBO?.isCompleted " value="fourteen"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label> Federal government</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity15" value="fifteen"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>REMIC </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity16" value="sixteen"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Indian tribal governments/enterprises</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity17" value="seventeen"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                (click)="radio8()">
                            </div>
                            <div class="col-lg-6">
                              <label>Group Exemption Number (GEN) if any ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!ssnbool8 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny">
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3">
                  <p>9b&nbsp;&nbsp; If a corporation, name the state or foreign country (if
                    applicable) where incorporated</p>
                </div>
                <div class="col-3">
                  <label>State
                  </label>
                  <ng-select
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.state_9b"
                    [items]="stateList" class="width25" [searchable]="true" [clearable]="true" bindLabel="name"
                    bindValue="abbreviation" [disabled]="clientonboardBO?.isCompleted ">
                  </ng-select>
                </div>
                <div class="col-3">
                  <label>Foreign country
                  </label>
                  <input type="text" class="form-control" [disabled]="clientonboardBO?.isCompleted "
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.foreignCountry">
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">

                        <div class="col-8">

                          <label>10&nbsp;&nbsp;Reason for applying (check only one box)
                          </label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange1($event)" name="business1" value="a"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="1" [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-6">
                              <label>Started new business (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool1"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radioevent()" name="business2" value="b"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="2">
                            </div>
                            <div class="col-lg-6">
                              <label>Hired employees (Check the box and see line 13.)
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radioevent()" name="business3" value="c"
                                [disabled]="clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="3">

                            </div>
                            <div class="col-lg-6">
                              <label>Compliance with IRS withholding regulations
                              </label>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange2($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business4" value="d"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="4">

                            </div>
                            <div class="col-lg-6">
                              <label>Other (specify) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool2 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify">

                            </div>
                          </div>

                        </div>
                        <div class="col-lg-6">

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange3($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business5" value="f"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="6">
                            </div>
                            <div class="col-lg-6">
                              <label>Banking purpose (specify purpose) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool3 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange4($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business6" value="g"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="7">
                            </div>
                            <div class="col-lg-6">
                              <label>Changed type of organization (specify new type) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool4 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange5($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business7" value="h"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="8">
                            </div>
                            <div class="col-lg-6">
                              <label>Purchased going business</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool5 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext">
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange6($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business8" value="i"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="9">
                            </div>
                            <div class="col-lg-6">
                              <label>Created a trust (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool6 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange7($event)"
                                [disabled]="clientonboardBO?.isCompleted " name="business9" value="j"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                id="10">
                            </div>
                            <div class="col-lg-6">
                              <label>Created a pension plan (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [disabled]="!snbool7 || clientonboardBO?.isCompleted "
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType">
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">

                <div class="col-5">
                  <label>11&nbsp;&nbsp;Date business started or acquired (month, day, year). See instructions
                  </label>

                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                    [selDate]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted"
                    (inputFieldChanged)="newdates($event,'inputchange','business')"
                    (dateChanged)="newdates($event,'datechanged','business');"
                    [disabled]="clientonboardBO?.isCompleted ">

                  </my-date-picker>
                </div>
                <div class="col-5">
                  <label>12&nbsp;&nbsp;Closing month of accounting year
                  </label>

                  <input type="string" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.closingMonth"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
              </div>
              <div class="row mt-2">

                <div class="col-6">
                  <p>13&nbsp;&nbsp;Highest number of employees expected in the next 12 months (enter -0- if
                    none). If no employees expected, skip line 14.</p>
                  <div class="row">
                    <div class="col-3">
                      <label>Agricultural
                      </label>
                      <input type="text" class="form-control"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.no_of_employees_Agriculture"
                        [disabled]="clientonboardBO?.isCompleted ">
                    </div>
                    <div class="col-3">
                      <label>Household
                      </label>
                      <input type="text" [disabled]="clientonboardBO?.isCompleted " class="form-control"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.no_of_employees_HouseHold">
                    </div>
                    <div class="col-3">
                      <label>Other
                      </label>
                      <input type="text" [disabled]="clientonboardBO?.isCompleted " class="form-control"
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.no_of_employees_other">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="col-lg-10">
                    <p>14&nbsp;&nbsp;
                      If you expect your employment tax liability to be $1,000 or
                      less in a full calendar year and want to file Form 944
                      annually instead of Forms 941 quarterly, check here.
                      (Your employment tax liability generally will be $1,000
                      or less if you expect to pay $5,000 or less in total wages.)
                      If you don’t check this box, you must file Form 941 for
                      every quarter&nbsp;<input type="checkbox" [disabled]="clientonboardBO?.isCompleted "
                        [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.file_Form_941_every_quarter">
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-8">
                  <p>15&nbsp;&nbsp;
                    First date wages or annuities were paid (month, day, year). Note: If applicant is a withholding
                    agent, enter date income will first be paid to
                    nonresident alien (month, day, year) . . . . . . . . . . . ▶
                    <my-date-picker class="w-100" style="display:inline-block;width:150px;"
                      [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                      [selDate]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid"
                      (inputFieldChanged)="newdates($event,'inputchange','alien')"
                      (dateChanged)="newdates($event,'datechanged','alien');"
                      [disabled]="clientonboardBO?.isCompleted ">
                    </my-date-picker>
                  </p>
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-6">
                          <p>16&nbsp;&nbsp;Check one box that best describes the principal activity of your
                            business.</p>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="q"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="aa" name="principal1" [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-3">
                              <label>Construction </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="r"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="bb" name="principal2">
                            </div>
                            <div class="col-lg-3">
                              <label>Rental & leasing </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="s"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="cc" name="principal3">
                            </div>
                            <div class="col-lg-3">
                              <label>Transportation & warehousing</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="t"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="dd" name="principal4">
                            </div>
                            <div class="col-lg-3">
                              <label>Real estate</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="u"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="ee" name="principal5">
                            </div>
                            <div class="col-lg-3">
                              <label>Manufacturing </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="v"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="ff" name="principal6">
                            </div>
                            <div class="col-lg-3">
                              <label>Finance &
                                insurance</label>
                            </div>

                          </div>
                        </div>
                        <div class="col-6">
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="k"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="gg" name="principal7">
                            </div>
                            <div class="col-lg-3">
                              <label> Health care & social assistance </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="l"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="hh" name="principal8">
                            </div>
                            <div class="col-lg-3">
                              <label>Wholesale-agent/broker </label>
                            </div>

                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="m"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="ii" name="principal9">
                            </div>
                            <div class="col-lg-3">
                              <label>Accommodation & food service</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="n"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="jj" name="principal0">
                            </div>
                            <div class="col-lg-3">
                              <label> Wholesale-other</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" [disabled]="clientonboardBO?.isCompleted "
                                value="o"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="kk" name="principal11">
                            </div>
                            <div class="col-lg-3">
                              <label> Retail </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" [disabled]="clientonboardBO?.isCompleted " value="p"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                id="ll" name="principal22" (ngModelChange)="otherchange($event)">
                            </div>
                            <div class="col-lg-3">
                              <label>Other (specify) ▶</label>
                            </div>
                            <div class="col-lg-3">
                              <input type="text" [disabled]="!otherbool || clientonboardBO?.isCompleted "
                                class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.othertext_16">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-8">
                  <p> 17&nbsp;&nbsp;Indicate principal line of merchandise sold, specific construction work done,
                    products produced, or services provided.<input type="text" class="form-control "
                      [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.indicate_Principle_line"
                      style="display:inline-block;width:150px;" [disabled]="clientonboardBO?.isCompleted ">
                  </p>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <p>18&nbsp;&nbsp;Has the applicant entity shown on line 1 ever applied for and received an
                    EIN? Yes No
                    If “Yes,” write previous EIN here ▶.<input type="text" [disabled]="clientonboardBO?.isCompleted "
                      [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicant_entity_shown_line1_everapplied_for_and_received_an_EIN_if_yes"
                      class="form-control " style="display:inline-block;width:150px;">
                  </p>&nbsp;&nbsp;

                  <div class="col-lg-2">
                    <label>Yes</label>
                    <input type="radio" id="pre1" value="true" name="select5"
                      [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein"
                      [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange3($event)">
                  </div>
                  <div class="col-lg-2">
                    <label>No</label>
                    <input type="radio" value="false" id="pre2" name="select5"
                      [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein"
                      [disabled]="clientonboardBO?.isCompleted " (ngModelChange)="authchange3($event)">
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5>Complete this section only if you want to authorize the named individual to receive the
                        entity’s EIN and answer questions about the completion of this form.</h5>
                    </div>
                    <div class="card-body" style="padding:45px;">

                      <div class="row">
                        <div class="col-2">
                          <div class="row">
                            <div class="col">
                              <div class="card">
                                <div class="card-body">
                                  <h4><b>Third
                                      Party
                                      Designee</b></h4>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-5">
                          <label>Designee’s name </label>

                          <input type="text" class="form-control"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designeesName"
                            [disabled]="clientonboardBO?.isCompleted ">
                          <label>Address and ZIP code
                          </label>
                          <textarea class="form-control" [disabled]="clientonboardBO?.isCompleted "
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_Address_ZipCode"></textarea>
                        </div>
                        <div class="col-5" [formGroup]="EmployerIdentificationForm">
                          <label>Designee’s telephone number (include area code)</label>

                          <input type="text" (keypress)="keyPress($event)" class="form-control"
                            formControlName="Designetele" [disabled]="clientonboardBO?.isCompleted "
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_telephone_number"
                            (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                            (keypress)="keyPress($event)">
                          <span class="req" *ngIf="EmployerIdentificationForm.controls['Designetele'].invalid">

                            <p>*Enter Valid phone, Enter 10 digit</p>
                          </span>
                          <label>Designee’s fax number (include area code)</label>
                          <input type="text" class="form-control" formControlName="Designefax"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_Fax_Number"
                            (keypress)="keyPress($event)" (ngModelChange)="DemographicPhoneFormat()" minlength="14"
                            maxlength="14" (keypress)="keyPress($event)" [disabled]="clientonboardBO?.isCompleted ">

                          <span class="req" *ngIf="EmployerIdentificationForm.controls['Designefax'].invalid">

                            <p>*Enter Valid fax, Enter 10 digit</p>
                          </span>
                        </div>

                      </div>

                      <div class="row mt-2">
                        <div class="col-7">
                          <div class="row">
                            <div class="col-12">
                              <p>Under penalties of perjury, I declare that I have examined this application, and to
                                the best of my knowledge and belief, it is true, correct, and complete.
                                Name and title (type or print clearly) ▶<input type="text"
                                  [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.under_penalties_of_perjury_Name_title"
                                  [disabled]="clientonboardBO?.isCompleted " class="form-control "
                                  style="display:inline-block;width:150px;">
                                <ng-select [items]="selflist" class="width25" [searchable]="true"
                                  style="display:inline-block;width:150px;" [clearable]="true" bindLabel="lovName"
                                  bindValue="id" placeholder="Choose One"
                                  [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.under_penalties_of_perjury_Name_titleLid"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                </ng-select>
                              </p>

                            </div>
                          </div>
                        </div>
                        <div class="col-5" [formGroup]="EmployerIdentificationForm">

                          <label>Applicant’s telephone number (include area code)</label>
                          <input type="text" (keypress)="keyPress($event)" class="form-control"
                            formControlName="applitele"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Telephone_Number"
                            (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                            [disabled]="clientonboardBO?.isCompleted ">
                          <span class="req" *ngIf="EmployerIdentificationForm.controls['applitele'].invalid">
                            <p>*Enter Valid phone, Enter 10 digit</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-7">

                          <div class="row mt-4 ms-2">
                            <div class="col-5">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#user" [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'">
                                Signature
                              </button>
                            </div>
                            <div class="col-lg-2">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-4">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                                [selDate]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date"
                                (inputFieldChanged)="newdates($event,'inputchange','appdate')"
                                (dateChanged)="newdates($event,'datechanged','appdate')"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted">

                              </my-date-picker>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signature!=''&& signature!=null " type="image" src="{{signature}}"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.signature"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>


                        </div>
                        <div class="col-5" [formGroup]="EmployerIdentificationForm">
                          <label>Applicant’s fax number (include area code)</label>
                          <input type="text" class="form-control" formControlName="applifax"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Fax_Number"
                            (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                            (keypress)="keyPress($event)" [disabled]="clientonboardBO?.isCompleted ">

                          <span class="req" *ngIf="EmployerIdentificationForm.controls['applifax'].invalid">

                            <p>*Enter Valid fax, Enter 10 digit</p>
                          </span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" [disabled]="clientonboardBO?.isCompleted || isSaveorUpdateBoolean"
                    (click)="SaveDocument()">Save</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- //////////////////////////////////// 2678 Employer/Payer Appointment of Agent /////////////////////////////////// /-->

      <div class="row mb-2">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">


              <h3>Form <b>2678 Employer/Payer Appointment of Agent</b></h3>
              <div class="row mt-2 ms-1">
                <p>
                  (Rev. August 2023)Department of the Treasury — Internal Revenue Service
                </p>
              </div>
              <div class="row mt-2">
                <div class="col-lg-8">
                  <p>Use this form if you want to request approval to have an agent file returns and make
                    deposits or payments of employment or other withholding taxes or if you want to
                    revoke an existing appointment. </p>
                  <p>• If you are an employer or payer who wants to request approval, complete Parts 1
                    and 2 and sign Part 2. Then give it to the agent. Have the agent complete Part 3 and
                    sign it. </p>
                  <p>
                    Note. This appointment is not effective until we approve your request. See the instructions
                    for filing Form 2678 on page 3.
                  </p>
                  <p>• If you are an employer, payer, or agent who wants to revoke an existing appointment,
                    complete all three parts. In this case, only one signature is required.</p>

                </div>
                <div class="col-lg-4">
                  <div class="row mb-2" style="height:150px">
                    <div class="col">
                      <div class="card ">

                        <div class="card-body">
                          <div>
                            <h5 style="background-color: black;color:white">For IRS Use</h5>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 1:</b>&nbsp;<b>Why you are filing this form...</b></h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <p>(Check one) </p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="radio" value="check1"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.appointorRevoke"
                            [disabled]="clientonboardBO?.isCompleted ">

                        </div>
                        <div class="col-lg-8">
                          <label>You want to appoint an agent for tax reporting, depositing, and paying. </label>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="radio" value="check2"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.appointorRevoke"
                            [disabled]="clientonboardBO?.isCompleted">
                        </div>
                        <div class="col-lg-8">
                          <label>You want to revoke an existing appointment. </label>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 2:</b>&nbsp;<b>Employer or Payer Information: Complete this part if you want to
                          appoint an agent or revoke an appointment</b></h5>
                    </div>
                    <div class="card-body" style="padding:35px;">
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>1.&nbsp;Employer identification number (EIN) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employeeIndentificationNumber"
                            class="form-control" [disabled]="clientonboardBO?.isCompleted ">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>2.&nbsp;Employer’s or payer’s name
                            (not your trade name)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName"
                            class="form-control" [disabled]="clientonboardBO?.isCompleted ">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>3.&nbsp;Trade name (if any) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.tradeName"
                            class="form-control" [disabled]="clientonboardBO?.isCompleted">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>4.&nbsp;Address </label>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4"> <label>Number </label></div>

                            <div class="col-lg-4"> <label>Street </label></div>

                            <div class="col-lg-4"> <label>Suite or room number</label></div>

                          </div>
                          <div class="row">
                            <div class="col-lg-4">
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.number"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-lg-4">
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentStreet"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-lg-4">
                              <textarea class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber"
                                [disabled]="clientonboardBO?.isCompleted"></textarea>
                            </div>
                          </div>



                        </div>

                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4">
                              <label>City</label>
                              <input type="text"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity"
                                [disabled]="clientonboardBO?.isCompleted" class="form-control">
                            </div>
                            <div class="col-lg-4">
                              <label>State</label>
                              <ng-select [items]="stateList" class="width25" [searchable]="true"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState"
                                [clearable]="true" bindLabel="name" bindValue="abbreviation"
                                [disabled]="clientonboardBO?.isCompleted">
                              </ng-select>
                            </div>
                            <div class="col-lg-4" [formGroup]="EmployerORPayerForm">
                              <label>Zip Code</label>

                              <input type="text" (keypress)="keyPress($event)" minlength="5" maxlength="11"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip"
                                [disabled]="clientonboardBO?.isCompleted" class="form-control"
                                formControlName="Payerzip1">
                              <span class="req" *ngIf="EmployerORPayerForm.controls['Payerzip1'].invalid">

                                <p>*Enter Valid zip,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div style="margin-top: 20px;">
                        <table class="table table-bordered table-responsive">
                          <tr>

                            <th style="width: 40%;"> <b>5.&nbsp;Forms for which you want to appoint an agent or
                                revoke the agent’s
                                appointment to file. </b>(Check all that apply.)</th>
                            <th style="width:10%">For ALL
                              employees/
                              payees/payments</th>
                            <th style="width:10%"> <b>For SOME
                                employees/
                                payees/payments</b></th>


                          </tr>
                          <tr>
                            <td style="text-align:left;">Form 940, 940-PR (Employer's Annual Federal Unemployment
                              (FUTA) Tax Return)*
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.futaForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.futaForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>

                          <tr>
                            <td style="text-align: left;">
                              Form 943, 943-PR (Employer’s Annual Federal Tax Return for Agricultural Employees)
                            </td>

                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersQuarterlyFederalTaxForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersQuarterlyFederalTaxForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>

                          <tr>
                            <td style="text-align: left;">Form 944, 944(SP) (Employer’s ANNUAL Federal Tax Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualFederalTaxReturnForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualFederalTaxReturnForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align:left;">Form 945 (Annual Return of Withheld Federal Income Tax)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align:left;">Form CT-1 (Employer’s Annual Railroad Retirement Tax
                              Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualRailroadRetirementTaxReturnForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualRailroadRetirementTaxReturnForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align: left;">Form CT-2 (Employee Representative's Quarterly Railroad
                              Tax Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employeeRepresentativesQuarterlyRailroadTaxReturnForAll"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employeeRepresentativesQuarterlyRailroadTaxReturnForSome"
                                [disabled]="clientonboardBO?.isCompleted">
                            </td>
                          </tr>



                        </table>
                      </div>
                      <div class="row mt-3 ms-2">
                        <p>*Generally you cannot appoint an agent to report, deposit, and pay tax reported on Form
                          940, Employer's Annual Federal
                          Unemployment (FUTA) Tax Return, unless you are a home care service recipient.</p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="checkbox"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.ifyou_are_home_care_service_recipient"
                            [disabled]="clientonboardBO?.isCompleted">
                        </div>
                        <div class="col-lg-8">
                          <label>Check here if you are a home care service recipient, and you want to appoint the
                            agent to report, deposit, and pay FUTA
                            tax for you. See the instructions</label>
                        </div>
                      </div>
                      <div class="row mt-2 ms-2">
                        <p>I am authorizing the IRS to disclose otherwise confidential tax information to the agent
                          relating to the authority granted under this
                          appointment, including disclosures required to process Form 2678. The agent may contract
                          with a third party, such as a
                          reporting agent or certified public accountant, to prepare or file the returns covered by
                          this appointment, or to make any required
                          deposits and payments. Such contract may authorize the IRS to disclose confidential tax
                          information of the employer/payer and
                          agent to such third party. If a third party fails to file the returns or make the deposits
                          and payments, the agent and employer/
                          payer remain liable.
                        </p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                          <div class="row mt-5 ms-2">
                            <div class="col-6">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'" data-bs-target="#signid">
                                Sign your
                                name here
                              </button>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signhere1!=''&& signhere1!=null" type="image" src="{{signhere1}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <div class="row mt-5 ms-2">
                            <div class="col-lg-3">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-5">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                                [selDate]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate"
                                (inputFieldChanged)="newdates($event,'inputchange','payerdate1')"
                                (dateChanged)="newdates($event,'datechanged','payerdate1')"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted">

                              </my-date-picker>
                            </div>

                          </div>
                        </div>




                        <div class="col-lg-6">
                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Type your name here</label></div>
                            <div class="col-lg-5"><input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.typeName"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Choose your title here</label></div>
                            <div class="col-lg-5">
                              <ng-select [items]="selflist" class="width25" [searchable]="true"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentTitleLid"
                                style="display:inline-block;width:150px;" [clearable]="true" bindLabel="lovName"
                                bindValue="id" placeholder="Choose One" [disabled]="clientonboardBO?.isCompleted ">
                              </ng-select>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Best daytime phone
                              </label></div>
                            <div class="col-lg-5" [formGroup]="EmployerORPayerForm"> <input type="text"
                                class="form-control" formControlName="Payerphone1"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.dayTimePhone"
                                (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)" [disabled]="clientonboardBO?.isCompleted ">
                              <span class="req" *ngIf="EmployerORPayerForm.controls['Payerphone1'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2 mt-4 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 3:</b>&nbsp;<b>Agent Information: If you will be an agent for an employer or
                          payer, or want to revoke an appointment, complete this part</b></h5>
                    </div>
                    <div class="card-body" style="padding:35px;">
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>6.&nbsp;Agent’s employer identification number (EIN)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" class="form-control"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentEmployerIndentificationNumber"
                            [disabled]="clientonboardBO?.isCompleted">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>7.&nbsp;Agent’s name (not trade name)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName"
                            [disabled]="clientonboardBO?.isCompleted" class="form-control">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>8.&nbsp;Trade name (if any) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" class="form-control"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentTradeName"
                            [disabled]="clientonboardBO?.isCompleted ">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>4.&nbsp;Address </label>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4"> <label>Number </label></div>

                            <div class="col-lg-4"> <label>Street </label></div>

                            <div class="col-lg-4"> <label>Suite or room number</label></div>

                          </div>

                          <div class="row">
                            <div class="col-lg-4">
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctNumber"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-lg-4">
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.street"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-lg-4">
                              <textarea class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber"
                                [disabled]="clientonboardBO?.isCompleted"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4">
                              <label>City</label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.city"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-lg-4">
                              <label>State</label>
                              <ng-select [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.state"
                                [disabled]="clientonboardBO?.isCompleted" bindLabel="name" bindValue="abbreviation">
                              </ng-select>
                            </div>
                            <div class="col-lg-4" [formGroup]="EmployerORPayerForm">
                              <label>Zip Code</label>
                              <input type="string" (keypress)="keyPress($event)" minlength="5" maxlength="11"
                                class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.zip"
                                [disabled]="clientonboardBO?.isCompleted" formControlName="Payerzip2">
                              <span class="req" *ngIf="EmployerORPayerForm.controls['Payerzip2'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digit</p>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="checkbox"
                            [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.ifyou_are_home_care_service_recipient"
                            [disabled]="clientonboardBO?.isCompleted ">
                        </div>
                        <div class="col-lg-8">
                          <label>Check here if the employer is a home care service recipient receiving home care
                            services through a program administered by a
                            federal, state, or local government agency</label>
                        </div>
                      </div>
                      <div class="row mt-3 ms-2">
                        <p>Under penalties of perjury, I declare that I have examined this form and any attachments,
                          and to the best of my knowledge and belief, it
                          is true, correct, and complete. </p>
                      </div>

                      <div class="row mt-2">
                        <div class="col-lg-6">

                          <div class="row mt-5 ms-2">
                            <div class="col-6">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'"
                                data-bs-target="#signhere2">
                                Sign your
                                name here
                              </button>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signhere2!=''&& signhere2!=null " type="image" src="{{signhere2}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <div class="row mt-5 ms-2">
                            <div class="col-lg-3">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-5">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [selDate]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate"
                                placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="newdates($event,'inputchange','payerdate2')"
                                (dateChanged)="newdates($event,'datechanged','payerdate2')"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted">

                              </my-date-picker>
                            </div>

                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Type your name here</label></div>
                            <div class="col-lg-5"><input type="text"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentTypeName"
                                class="form-control" [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Choose your title here</label></div>
                            <div class="col-lg-5">
                              <ng-select [items]="selflist" class="width25" [searchable]="true"
                                style="display:inline-block;width:150px;" [clearable]="true" bindLabel="lovName"
                                bindValue="id" placeholder="Choose One"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.titleLid"
                                [disabled]="clientonboardBO?.isCompleted">
                              </ng-select>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Best daytime phone
                              </label></div>
                            <div class="col-lg-5" [formGroup]="EmployerORPayerForm"> <input type="text"
                                class="form-control" formControlName="Payerphone2"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentDayTimePhone"
                                (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)" [disabled]="clientonboardBO?.isCompleted ">
                              <span class="req" *ngIf="EmployerORPayerForm.controls['Payerphone2'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" [disabled]="clientonboardBO?.isCompleted || isSaveorUpdateBoolean"
                    (click)="SaveDocument()">Save</button>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- //////////////////////////////////// indivual Or SoleProPreitor Power /////////////////////////////////// /-->

      <div class="row mb-2">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">

              <div class="row mt-2">
                <div class="col-10">
                  <img src="..\assets\img\indivual.JPG" class="img-fluid" alt="Responsive image">
                </div>
              </div>
              <div class="row mt-2 ms-2">
                <p><b>Read Instructions before completing this form.To grant authority for a business,complete form
                    REV184b,Business Power of Attorney</b></p>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\taxpayer.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-11">
                          <div class="row mt-2">
                            <div class="col-6">
                              <label>Taxpayer Name</label>

                              <input type="text" class="form-control" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName">
                              <label>Street Address or PO Box
                              </label>
                              <textarea class="form-control" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox"></textarea>


                            </div>
                            <div class="col-6" [formGroup]="IndivualForm">
                              <label>Social Security Number or ITIN</label>

                              <input type="text" class="form-control" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.social_Security_number_or_Itin"
                                formControlName="ssn1" (keypress)="keyPress($event)" minlength="9" maxlength="9">
                              <span class="req" *ngIf="IndivualForm.controls['ssn1'].invalid">

                                <p>*Enter Valid ssn ,Enter 9 digit</p>
                              </span>


                              <label>Minnesota or Federal Employer Identification Number (FEIN) (Sole
                                proprietors)</label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.minnesota_or_Federal_Employer_Identification_Number"
                                formControlName="Minnesota" [disabled]="clientonboardBO?.isCompleted ">

                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-4">
                              <label>Apt or Suite
                              </label>
                              <input type="text" class="form-control" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit">
                            </div>
                            <div class="col-lg-4" [formGroup]="IndivualForm">
                              <label>Phone Number </label>
                              <input type="text"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber"
                                class="form-control" formControlName="phone1" (ngModelChange)="DemographicPhoneFormat()"
                                minlength="14" maxlength="14" (keypress)="keyPress($event)"
                                [disabled]="clientonboardBO?.isCompleted">
                              <span class="req" *ngIf="IndivualForm.controls['phone1'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>
                            </div>
                            <div class="col-lg-4" [formGroup]="IndivualForm">
                              <label>Fax Number </label>
                              <input type="text"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.faxNumber"
                                class="form-control" formControlName="fax1" [disabled]="clientonboardBO?.isCompleted"
                                (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)">
                              <span class="req" *ngIf="IndivualForm.controls['fax1'].invalid">

                                <p>*Enter Valid fax,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                          <div class="row mt-2">

                            <div class="col-3">
                              <label>City
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.city"
                                [disabled]="clientonboardBO?.isCompleted">
                            </div>
                            <div class="col-2">
                              <label>State </label>

                              <ng-select
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.state"
                                [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation" [disabled]="clientonboardBO?.isCompleted">
                              </ng-select>
                            </div>
                            <div class="col-2" [formGroup]="IndivualForm">
                              <label>Zip Code </label>
                              <input type="string" (keypress)="keyPress($event)" maxlength="11" minlength="5"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode"
                                class="form-control" formControlName="zip1" [disabled]="clientonboardBO?.isCompleted">
                              <span class="req" *ngIf="IndivualForm.controls['zip1'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                            <div class="col-5">
                              <label>Email Address </label>

                              <input type="text" [disabled]="clientonboardBO?.isCompleted"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress"
                                class="form-control">


                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\second.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-11">
                          <div class="row mt-2">
                            <div class="col-6">
                              <label>Name of Appointee</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.name_of_Appointee"
                                [disabled]="clientonboardBO?.isCompleted ">
                              <label>Street Address or PO Box
                              </label>
                              <textarea class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Street_Address_or_PoBox"
                                [disabled]="clientonboardBO?.isCompleted "></textarea>


                            </div>
                            <div class="col-6">
                              <label>Attorney Number,Accountant Number or PTIN</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Attorney_Number_Accountant_Number_or_Ptin"
                                [disabled]="clientonboardBO?.isCompleted ">
                              <label>Phone Number</label>
                              <div [formGroup]="IndivualForm">
                                <input type="text" class="form-control" formControlName="phone2"
                                  [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber"
                                  (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                  (keypress)="keyPress($event)">
                                <span class="req" *ngIf="IndivualForm.controls['phone2'].invalid">

                                  <p>*Enter Valid phone,Enter 10 digit</p>
                                </span>
                              </div>

                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-6">
                              <label>Apt or Suite
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Apt_or_Suite"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>

                            <div class="col-lg-6" [formGroup]="IndivualForm">
                              <label>Fax Number</label>
                              <input type="text" class="form-control" formControlName="fax2"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_FaxNumber"
                                (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                [disabled]="clientonboardBO?.isCompleted ">
                              <span class="req" *ngIf="IndivualForm.controls['fax2'].invalid">

                                <p>*Enter Valid fax,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                          <div class="row mt-2">

                            <div class="col-3">
                              <label>City
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_city"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-2">
                              <label>State</label>

                              <ng-select
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_state"
                                [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation" [disabled]="clientonboardBO?.isCompleted ">
                              </ng-select>
                            </div>
                            <div class="col-2" [formGroup]="IndivualForm">
                              <label>Zip Code</label>
                              <input type="string" minlength="5" maxlength="11" class="form-control"
                                (keypress)="keyPress($event)" formControlName="zip2"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Zipcode"
                                [disabled]="clientonboardBO?.isCompleted ">
                              <span class="req" *ngIf="IndivualForm.controls['zip2'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                            <div class="col-5">
                              <label>Email Address</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_EmailAddress"
                                [disabled]="clientonboardBO?.isCompleted ">


                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <p>If Appointing more than one person enter on page 2 of this form</p>

              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\third.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>

                        <div class="col-11">
                          <div class="row mt-2" style="padding-left:20px;">
                            <p>I appoint the person above and anyone included on the attached list,to access my
                              information and represent me before the Minnesota department of Revenue.This authority
                              does not cover powers listed in the additional powers section below unless indicated
                            </p>
                            <p>check the box for <b>Limited Authority</b> or <b>Full Authority</b></p>
                            <div class="col-lg-9">
                              <div class="row">

                                <table class="table table-bordered table-responsive">
                                  <thead>
                                    <tr>
                                      <div class="row ms-2" id="radi">
                                        <div class="col-1">
                                          <input type="radio" value="limit"
                                            [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.lLmitedAthourity"
                                            [disabled]="clientonboardBO?.isCompleted ">
                                        </div>
                                        <div class="col-5">
                                          <label><b>Limited Authority</b></label>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-lg-12">
                                          <p>The Appointee is authorized to act on behalf but only for the following
                                          </p>

                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-lg-9">
                                          <p>Type Of Tax(such as income Estate,Property Tax Refund,Withholding)or Dept
                                            issue</p>
                                        </div>

                                        <div class="col-lg-3" style="text-align: right;">
                                          <label style="text-align: right;">Years or Periods</label>
                                          <p style="text-align: right;">(if Left blanks applies to all)</p>
                                        </div>
                                      </div>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>

                                      <td><label>Withholding Tax</label></td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods1"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>


                                    </tr>
                                    <tr>

                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax1"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods2"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>


                                    </tr>
                                    <tr>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax2"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods3"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>
                                    </tr>
                                    <tr>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax3"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods4"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                              </div>

                            </div>
                            <div class="col-lg-3">
                              <div class="row">

                                <div class="card">
                                  <div class="card-body">

                                    <div class="row ms-2" id="radi">
                                      <div class="col-1">
                                        <input type="radio" value="full"
                                          [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.lLmitedAthourity"
                                          [disabled]="clientonboardBO?.isCompleted ">
                                      </div>
                                      <div class="col-8">
                                        <label><b>Full Authority</b></label>
                                      </div>
                                    </div>
                                    <p class="card-text">this appointee is authorized to act on my behalf but only
                                      for all of my tax and debt issues for all years or periods</p>

                                  </div>
                                </div>

                              </div>

                            </div>


                          </div>
                          <div class="row mt-2 ms-3">
                            <div class="col-lg-5">
                              <label>Authority Expiration Date
                              </label>
                            </div>
                            <div class="col-lg-4">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [selDate]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date"
                                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','exdate')"
                                (dateChanged)="newdates($event,'datechanged','exdate')"
                                [disabled]="clientonboardBO?.isCompleted ">

                              </my-date-picker>
                            </div>
                          </div>


                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">

                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\addpower.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-10">
                          <div class="row mt-2">
                            <p>Add the following powers to the appointees limited or full authority (check any that
                              apply)</p>
                          </div>
                          <div class="row mt-2">

                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.communicate_with_the_department_by_email"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Communicate with the department by email</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.add_additional_appointees"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Add additional appointees(primary Appointee only)</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.sign_returns_and_other_tax_forms"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>sign returns and other tax forms</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.receive_all_mail_except_refunds"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Receive all mail except refunds(see instructions)(primary Appointee
                                only)</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.extend_statute_of_limitations_to_assess_tax"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Extend statute of limitations to assess tax</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authorize_the_department_to_release_return_information_third_parties"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Authorize the department to release my return information to third
                                parties</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.excute_Agreements"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Excute Agreements</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.act_on_my_behalf_i_became_incapacitated_or_incompetent"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-lg-5">
                              <label>Act on my behalf if i became incapacitated or incompetent(Durable POA)</label>
                            </div>
                          </div>



                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\signature.jpg" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-10">
                          <div class="row mt-2">
                            <p>This power of Attorney is not valid until it is signed and dated by the Taxpayer</p>
                            <p>parent,Gurdian,conservation i certify that i have the legal authority to sign this
                              form</p>
                          </div>

                          <div class="row">
                            <div class="col-3">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#power" [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD'">
                                Signature
                              </button>
                            </div>
                            <div class="col-lg-1">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-2">
                              <my-date-picker class="w-100"
                                [selDate]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate"
                                [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="newdates($event,'inputchange','exdate1')"
                                (dateChanged)="newdates($event,'datechanged','exdate1');"
                                [disabled]="global.LoginUserType.toUpperCase() != 'ONBOARD' && clientonboardBO?.isCompleted">

                              </my-date-picker>
                            </div>
                            <div class="col-lg-3">
                              <label>Address If Different from Taxpayer</label>
                            </div>
                            <div class="col-lg-3">
                              <textarea class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.address_If_Different_from_Taxpayer"
                                [disabled]="clientonboardBO?.isCompleted "></textarea>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="Partisign!=''&& Partisign!=null " type="image" src="{{Partisign}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <p>Print Name and Title If applicable</p>
                          <div class="row mt-2">
                            <div class="col-lg-6">
                              <div class="row">
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.print_Name_and_If_applicable"
                                    [disabled]="clientonboardBO?.isCompleted ">
                                </div>
                                <div class="col-lg-6">

                                  <ng-select [items]="selflist" class="width25" [searchable]="true"
                                    style="display:inline-block;width:150px;" [clearable]="true" bindLabel="lovName"
                                    bindValue="id" placeholder="Choose One"
                                    [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.chooseTitleLid"
                                    [disabled]="clientonboardBO?.isCompleted ">
                                  </ng-select>
                                </div>
                              </div>


                            </div>
                            <div class="col-lg-6">
                              <div class="row">
                                <div class="col-lg-4">
                                  <label>Phone Number</label>
                                </div>
                                <div class="col-lg-6" [formGroup]="IndivualForm">

                                  <input type="text" class="form-control" formControlName="phone3"
                                    [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signPhoneNumber"
                                    (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14"
                                    (keypress)="keyPress($event)" [disabled]="clientonboardBO?.isCompleted ">

                                  <span class="req" *ngIf="IndivualForm.controls['phone3'].invalid">

                                    <p>*Enter Valid phone ,Enter 10 digit</p>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-4">
                              <label>City
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_City"
                                [disabled]="clientonboardBO?.isCompleted ">
                            </div>
                            <div class="col-4">
                              <label>State</label>

                              <ng-select
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_State"
                                [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation" [disabled]="clientonboardBO?.isCompleted ">
                              </ng-select>
                            </div>
                            <div class="col-3" [formGroup]="IndivualForm">
                              <label>Zip Code</label>
                              <input type="string" minlength="5" maxlength="11" (keypress)="keyPress($event)"
                                class="form-control" formControlName="zip3"
                                [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_Zipcode"
                                [disabled]="clientonboardBO?.isCompleted ">

                              <span class="req" *ngIf="IndivualForm.controls['zip3'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digit</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

              <div class="row ms-2">
                <p><b>Send a signed copy of this form to the Deportment</b></p>
              </div>
              <div class="row ms-2">
                <p><b>Mail: &nbsp;&nbsp;Minnesota Deportment Of Revenue,Mail Station 4123,600N,Robert st.,st.Paul,MN
                    55146</b></p>
              </div>
              <div class="row ms-2">
                <p><b>FAX:&nbsp;&nbsp;651-556-5210</b></p>
              </div>
              <div class="row ms-2">
                <p><b>Email&nbsp;&nbsp;:MNDOR,POA@State.mn.us</b></p>
              </div>

              <div class="row mt-4">
                <div class="col-lg-12" style="text-align:center">
                  <h4><b>Additional Appointees</b></h4>
                </div>

              </div>

              <div class="row mt-3">
                <div class="col-lg-6">
                  <label>Name of Taxpayer</label>
                  <input type="text" class="form-control"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointee_Form1_Name_of_Taxpayer"
                    [disabled]="clientonboardBO?.isCompleted ">
                </div>
                <div class="col-lg-6" [formGroup]="IndivualForm">
                  <label>SSN,ITIN,MN ID,or FEIN</label>
                  <input type="text" class="form-control" formControlName="ssn2"
                    [(ngModel)]="ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointee_Form1_SsN_Itin_Mn_Id_or_Fein"
                    minlength="9" maxlength="9" (keypress)="keyPress($event)"
                    [disabled]="clientonboardBO?.isCompleted ">
                  <span class="req" *ngIf="IndivualForm.controls['ssn2'].invalid">

                    <p>*Enter Valid ssn,Enter 9 digit</p>
                  </span>
                </div>
              </div>

              <div class="row mt-2 ms-2">
                <p>include any appointees below Additional appointees only have authority over matters choose in the
                  Authority Granted and Additional powers section on page 1.</p>
              </div>

              <div class="row mt-2 mb-3">
                <div id="goalaccordion" class="col-lg-12"
                  *ngFor="let item of ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress;let goal1=index">
                  <div class="col">
                    <div class="card ">

                      <div class="card-body" style="padding:25px;">

                        <div class="row">
                          <div class="col-lg-10">
                            <a style="color:#004290" data-bs-toggle="collapse"
                              attr.data-bs-target="#collapse_{{goal1}}">

                            </a>
                          </div>
                          <div class="col-lg-2 text-end">

                            <button class="btn btn-delete-table" *ngIf="goal1==0"
                              (click)="CreateAdditionalAppointees()"><i class="fa fa-plus-circle"></i></button>

                            <button class="btn btn-delete-table" *ngIf="AppointeeBoolean&&goal1!=0"
                              (click)="RemoveAdditionalAppointees(goal1);"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row mt-2">
                              <div class="col-6">
                                <label>Name of Appointee</label>

                                <input type="text" class="form-control" [(ngModel)]="item.nameofAppointee"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                <label>Street Address or PO Box
                                </label>
                                <textarea class="form-control" [(ngModel)]="item.street_Address_or_PoBox"
                                  [disabled]="clientonboardBO?.isCompleted "></textarea>


                              </div>
                              <div class="col-6">
                                <label>Attorney Number,Accountant Number or PTIN</label>

                                <input type="text" class="form-control"
                                  [(ngModel)]="item.attorneyNumber_AccountantNumber_or_Ptin"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                <label>Phone Number</label>
                                <input type="text" class="form-control" [(ngModel)]="item.phoneNumber"
                                  (ngModelChange)="DemographicPhoneFormat();validchange1(goal1,item);" minlength="14"
                                  maxlength="14" (keypress)="keyPress($event)"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                <span class="err" *ngIf="errphone1">{{phonerr1[goal1]}}</span>


                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-lg-6">
                                <label>Apt or Suite
                                </label>
                                <input type="text" class="form-control" [(ngModel)]="item.apt_or_Suite"
                                  [disabled]="clientonboardBO?.isCompleted ">
                              </div>

                              <div class="col-lg-6">
                                <label>Fax Number</label>
                                <input type="text" class="form-control" [(ngModel)]="item.faxNumber"
                                  (ngModelChange)="DemographicPhoneFormat();validchange2(goal1,item)" minlength="14"
                                  maxlength="14" (keypress)="keyPress($event)"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                <span class="err" *ngIf="errphone2">{{phonerr2[goal1]}}</span>

                              </div>
                            </div>
                            <div class="row mt-2">

                              <div class="col-3">
                                <label>City
                                </label>
                                <input type="text" class="form-control" [(ngModel)]="item.city"
                                  [disabled]="clientonboardBO?.isCompleted ">
                              </div>
                              <div class="col-2">
                                <label>State</label>

                                <ng-select [(ngModel)]="item.state" [items]="stateList" class="width25"
                                  [searchable]="true" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                                  [disabled]="clientonboardBO?.isCompleted ">
                                </ng-select>
                              </div>
                              <div class="col-2">
                                <label>Zip Code</label>
                                <input type="string" class="form-control" (keypress)="keyPress($event)"
                                  [(ngModel)]="item.zip" (ngModelChange)="validchange3(goal1,item);"
                                  [disabled]="clientonboardBO?.isCompleted " maxlength="11" minlength="5">
                                <span class="err" *ngIf="ziperr">{{ziperr[goal1]}}</span>

                              </div>
                              <div class="col-5">
                                <label>Email Address</label>
                                <input type="text" class="form-control" [(ngModel)]="item.email"
                                  [disabled]="clientonboardBO?.isCompleted ">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col text-end mb-3 mt-3">
                  <button type="button" class="btn blue-btn me-3" [disabled]="clientonboardBO?.isCompleted || isSaveorUpdateBoolean"
                    (click)="SaveDocument()">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ////////////////////////////////////////// SIGNATURE PART//////////////////////////////// -->

<div class="modal fade" id="signid" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #signpadone [options]="signaturePadOptions" (onEndEvent)="here()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Clear()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="signhere2" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #signpadtwo [options]="signaturePadOptions" (onEndEvent)="here2()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Clear2()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="user" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #userpad [options]="signaturePadOptions" (onEndEvent)="user()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearuser()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Participant2" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #pantpad [options]="signaturePadOptions" (onEndEvent)="pant()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearpant()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="power" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #powerpad [options]="signaturePadOptions" (onEndEvent)="Parti()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearParti()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Participant3" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #pantpad1 [options]="signaturePadOptions" (onEndEvent)="pant1()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearpant1()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="clocompletemodalsedeletemodal"
          data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- ////////////////////////////////////// COMPLETE DOCUMENT /////////////////////////////////////// -->

<span id="Opencompletemodal" data-bs-toggle="modal" data-bs-target="#completemodal"></span>
<div class="modal hide fade modalbackgrod" id="completemodal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog  ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Complete Application</h5>
        <button type="button" class="close" data-bs-dismiss="modal" (click)="clearCompleteFields()">&times;</button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col-8">
            <p>Are you sure you want to Complete?</p>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="CommonSave()">Yes
        </button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- ///////////////////////////////// SENT TO CLIENT  DOCUMENT //////////////////////////// -->

<span id="send_to_client" data-bs-toggle="modal" data-bs-target="#sendtoclient"></span>
<div class="modal hide fade modalbackgrod" id="sendtoclient" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Mail Notes</h5>
      </div>
      <div class="modal-body">

        <div class="col">
          <div class="col-lg-12">
            <label class=" mx-auto" style="font-size: 12px; color: red;"><i class="fa fa-info-circle fa-lg"></i>&nbsp;
              This will be attached in mail</label> <br>
            <label *ngIf="clientonboardBO?.datalist?.onboardStatusLidCode == 'SENTTOUSER'" class=" mx-auto"
              style="font-size: 12px; color: red;"><i class="fa fa-info-circle fa-lg"></i>&nbsp;
              Their Password will be Reset</label>
            <textarea class="form-control mx-auto" style="width: 100%; height: 104px"
              [(ngModel)]="SendToClientNotes"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="CommonSave()"><span>Send</span>
        </button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
          (click)="clearSendFields()">Close</button>
      </div>
    </div>
  </div>
</div>